import { Checkbox, styled } from '@nexelem/deprecated-theme';
import { forwardRef } from 'react';

export const PrivateStyledCheckbox = styled(Checkbox)(() => {
  return {
    padding: '10px',
    color: '#646D82',
    '&.Mui-checked': {
      color: '#3466E4',
    },
  };
});

export const StyledCheckbox = forwardRef<HTMLButtonElement, object>((props, ref) => (
  <PrivateStyledCheckbox {...props} ref={ref} />
));

StyledCheckbox.displayName = 'StyledCheckbox';
